import { AuthenticatedTileLayer } from "./AuthenticatedTileLayer";

export default AuthenticatedTileLayer;
